/* src/app/components/game-layer/characters-component/characters-component.css */
.character-roster {
  display: block;
}
.session-meta {
  display: grid;
  gap: 10px;
  margin: 0;
}
.session-meta div {
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(240, 215, 122, 0.12);
  background: rgba(255, 255, 255, 0.04);
}
.session-meta dt {
  margin: 0 0 4px;
  color: var(--gold-bright);
  font-size: 0.76rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.session-meta dd {
  margin: 0;
  color: var(--ink);
}
.validation-text {
  color: #ffb8a2;
}
@media (max-width: 640px) {
  .list-card .primary-btn {
    width: 100%;
  }
}
/*# sourceMappingURL=characters-component.css.map */
